/**
 * Search Interface, subclass for specific searches
 * requires backbone.js
 */
 


var SearchInterface = Backbone.Model.extend(
	/** @lends SearchInterface.prototype */
	{
		
	defaults: function() {
		return {
			id: '',
			type: '',
			name: '',
			site_url: '',
			search_url: '',
			results: [],
			total_results: 0,
			page: 1,
			perpage: 20,
			query_typed: null,
			query_obj: {},
			request_url: '',
			display_facets: false,
			item_template: '',
			item_callback: '',
			sort_options: [],
			sort: { field: '', dir: '' },
		};
	},

	/**
	 * The main search interface
	 * @param {Object} config variables from the search source data
	 * @param {String} config.id unique identifier for search source
	 * @param {String} config.type used by controller to know what class to use (should be unique across sources but not necessarily across instantiations of the subclass
	 * @param {String} config.name just a human readable label for the source
	 * @param {String} config.description text to describe the source for people
	 * @param {String} config.site_url top-level domain of the source (for making URLs)
	 * @param {String} [config.search_url] dedicated/advanced search url for source
	 * @param {Object} config.facets the facets as properties with their value as arrays of currently selected limits
	 * @param {Array} config.results the retrieved results for the current search page
	 * @param {Number} config.total_results how many total results for search/filters (independent of pagination)
	 * @param {Number} config.page currently view page
	 * @param {Number} config.perpage how many results per page
	 * @param {Object} config.sort default sorting parameters in the form of field and dir properties
	 * @param {String} config.query_typed the keyword search string
	 * @param {Object} config.query_obj all the fields and values that need to go to Solr for the query
	 * @param {String} config.request_url domain/path to request data from
	 * @param {Bool} config.display_facets do we show facets or not
	 * @param {String} config.item_template an mustache like template for result items
	 * @param {Function} config.item_callback callback applied to each result LI element after results are added to DOM
	 * @param {Object[]} config.sort_options options for sorting the results
	 * @param {String} config.sort_options[].field name of sorting field
	 * @param {String} config.sort_options[].dir direction of sort (asc/desc)
	 * @param {String} config.sort_options[].label human readable name of sorting field
	 * @param {Object} config.query_const key->value pairs to pass to request_url, you can also pass back these keys in the results to update them
	 */
	initialize: function(config) {
		searchcontroller.debug('SearchInterface '+this.get('type')+' initialize');
		this.resultCache = {};
		this.facetCache = {};
		
		this.protocol = window.location.protocol;
		
		//set config options
		this.setConfig(config);
		
		if (searchcontroller.get('layout') == 'bento') {
			this.set('perpage', 10);
		}
		
		if (this.get('search_url') !== '' && !_.isNull(this.get('search_url'))) {
			if ( this.get('search_url').substr(0, 4) !== 'http' && this.get('search_url').substr(0, 2) !== '//') {
				this.set('search_url', '//'+this.get('search_url'));
			}
		}
		
		//listen on SearchController for the search:initiate event this means the page has loaded, the keyword has changed, or tab was selected
		this.listenTo(searchcontroller, "search:initiate", this.newSearch);
		this.on('search:initiate', this.newSearch, this);
		//trigger events on the controller when results are or are not found
		this.on('search:noresults', this.controllerno, this);
		this.on('search:retrieve', this.controlleryes, this);
		
		//@todo this will need to be conditional on the controller... only viewed interfaces get initialized (or rather they get initialized when viewed)
		this.renderViews();
	},
	/**
	 * Tell the search controller there were no results
	 */
	controllerno: function(){
		searchcontroller.trigger('search:noresults', { source: this.get('id') });
	},
	/**
	 * Tell the search controller there were results retrieved
	 */
	controlleryes: function(){
		searchcontroller.trigger('search:retrieve', { source: this.get('id') });
	},
	/**
	 * Set properties based on config object sent from SearchController
	 * override in subclass as necessary
	 * @param {Object} config customer settings for this interface
	 * Object should at least contain id, type, name
	 */
	setConfig: function(config) {
		_.each(config, function(v,k,l){
			if (_.isNull(v)) { return; }
			this.set(k, v, { silent: true });
		}, this);
		
		this.set('selector', '#s-srch-source-'+this.get('id'), { silent: true });
		return;	
	},
	/**
	 * Load up the views for this interface
	 */
	renderViews: function(){
		var $container = jQuery(this.get('selector'));
		var views = [];
		
		var searchheader = new SearchHeader({ model: this, id: 's-srch-header-'+this.get('id') });
		
		if (searchcontroller.get('layout') !== 'bento') {
			var top_pagination = new PaginationView({ model: this, id: 's-srch-paginate-'+this.get('id')+'-top', location: 'top' });
			var searchfooter = { '$el': '' };
		} else {
			var top_pagination = { '$el': '' };
			var searchfooter = new SearchFooter({ model: this, id: 's-srch-footer-'+this.get('id') });
		}
		var bottom_pagination = new PaginationView({ model: this, id: 's-srch-paginate-'+this.get('id')+'-bottom', location: 'bottom' });
		var resultslist = new ResultsList({ model: this, id: 's-srch-results-'+this.get('id') });
		//var askform = new AskView({ model: this, formType: 'noresults', alert_text: this.get('lang').srch_notasked, source: this.get('id') });
		
		if (this.get('description') !== '') {
			views.push(
				jQuery('<div class="row"></div>').append(
					jQuery('<div>').addClass('col-sm-12 s-srch-description').attr('id', 's-srch-description-'+this.get('id')).append(
						jQuery('<p>').html(this.get('description'))
					)
				)
			);
		}
		views.push( jQuery('<div class="row"></div>').append([searchheader.$el, top_pagination.$el]) );
		views.push( jQuery('<div class="row"></div>').append(resultslist.$el) );
		views.push( jQuery('<div class="row"></div>').append([searchfooter.$el, bottom_pagination.$el]) );
		//views.push( jQuery('<div class="row"></div>').append(askform.$el) );
		
		$container.append( views );
	},
	/**
	 * Generate the query object for the search
	 * override in subclass
	 * sets the query_obj attribute
	 * @param {Boolean} [autocomp] is this an autocomplete request
	 */
	buildQuery: function(autocomp) {
		//searchcontroller.debug('buildQuery');
		
		qo = {
			q: this.convertSearch(),
			page: this.get('page')
		};
		
		//add search source id for locally proxied searches
		if ( this.get('request_url').match(/^\/[^/]/) !== null ) {
			qo.search_src_id = this.get('id');
		}
		
		s = this.get('sort');
		qo.sort = s.field+'_'+s.dir;
		
		if (this.get('query_const')) {
			_.each(this.get('query_const'), function(v,k){
				qo[k] = v;
			}, this);
		}
		
		this.set('query_obj', qo);
	},
	/**
	 * Take the typed query and fancy it up for use by the API
	 * override in subclass
	 */
	convertSearch: function() {
		return (this.get('query_typed') === null) ? '' : this.get('query_typed');
	},
	/**
	 * A new keyword search triggered by the SearchController
	 * @param {Object} d data passed to action via search:initiate event
	 * @param {String} d.source origin of search (controller, facet, sort, paginate)
	 */
	newSearch: function(d) {
		searchcontroller.debug(this.get('type')+' newSearch');
		if (searchcontroller.get('layout') !== 'bento') {
			//make sure it's for this tab
			if (parseInt(searchcontroller.get('tab'), 10) !== parseInt(this.get('id'), 10)) {
				jQuery(this.get('selector')).addClass('hidden');
				return;
			} else {
				jQuery(this.get('selector')).removeClass('hidden');
			}
		}
		
		if (d.source == 'controller' && this.get('query_typed') !== null && this.get('query_typed') === searchcontroller.get('query_typed')) {		
			//don't do anything if the query hasn't changed (probably this means we changed tabs)
			//trigger askform view
			if (this.get('total_results') == 0) {
				searchcontroller.trigger('askform:noresults');	
			} else {
				searchcontroller.trigger('askform:results');
			}
			return;
		}
		this.set('query_typed', searchcontroller.get('query_typed'));
		
		if (d.source !== 'paginate') {
			this.set('page', 1);  //reset page to 1
		}
		
		this.retrieve();
	},
	/**
	 * ajax call to source for results
	 * triggered on load and state change
	 */
	retrieve: function() {
		searchcontroller.debug(this.get('type')+' retrieve');
		
		//make sure we have the current query object
		this.buildQuery();
		
		//do we have this data cached?
		//set cache via...
		var cachename = JSON.stringify(this.get('query_obj'));
		if (this.resultCache[cachename]) {
			//searchcontroller.debug('cached!');
			this.parseResults(this.resultCache[cachename]);
			this.setFocus();
			return;
		}
		
		//the ajax itself
		this.requestData();
	},
	/**
	 * Request the data (an ajax request)
	 */
	requestData: function() {
		var self = this;
		
		workingAlert();
		try {
			$.ajax({
				url: this.get('request_url'),
				data: this.get('query_obj'),
				success: function(d, status){
					clearTimeout(requestError);
					self.cacheResults(d);
					self.parseResults(d);
					self.setFocus();
					stopAlert();
				},
				dataType: 'jsonp',
			});
			
			//because jsonp doesn't return errors normally we gotta just timeout
			var requestError = setTimeout(function() { 
				// Handle error accordingly
				errorAlert();
			}, 10000);
		
		} catch (e) {
			searchcontroller.debug('requestData exception for source '+this.get('id')+': '+e.message);
			errorAlert();
		}
	},
	/**
	 * Cache data based on query string so we can access it via the history state on back/forward button usage
	 * @param {Object} data results from solr
	 */
	cacheResults: function(data) {
		this.resultCache[JSON.stringify(this.get('query_obj'))] = data;
	},
	/**
	 * Cache facet data based on query object so we can access it via the history state on back/forward button usage
	 * @param {Object} data results from solr
	 */	
	cacheFacets: function(qs, data) {
		this.facetCache[qs] = data;		
	},
	/**
	 * Update the facets only for query string or group change.
	 * Facets are returned based on query string and group only.
	 */
	retrieveFacets: function() {
		return;
	},	
	/**
	 * Apply facet data retrieved from Solr
	 */
	parseFacets: function(data) {
		return;
	},
	/**
	 * Grab the results and trigger some actions on the various views
	 * @param {Object} data returned from query
	 * @param {Object[]} data.results array of result items
	 * @param {Object} data.results[] item object properties don't matter if we use a template
	 * @param {Number} data.total_results total hits for query
	 * @param {Number} data.perpage how many results per page
	 */
	parseResults: function(data) {
		var fields = {
			'results': [],
			'total_results': 0,
			'perpage': 0
		};
		
		if (_.isObject(data) & data != null) {		
			//trigger search:retrieve or search:noresults
			fields.results = (data.results) ? data.results : [];
			fields.total_results = (data.total_results) ? data.total_results : 0;
			fields.perpage = (data.perpage) ? data.perpage : 0;
			if (data.sort) {
				fields.sort = data.sort;
			}
			if (data.sort_options) {
				fields.sort_options = data.sort_options;
			}
		}
		this.set(fields);
		if (fields.total_results === 0) {
			this.trigger('search:noresults');	
		} else {
			this.trigger('search:retrieve');
		}
		if (this.get('display_facets')) {
			this.retrieveFacets();
		}
		
		if (this.get('query_const')) {
			//you can update the query_const by passing back a value in the results
			//this is especially used for EDS sessionid
			var query_const = _.clone(this.get('query_const'));
			var update = false;
			_.each(query_const, function(v,k){
				if (data[k]) {
					query_const[k] = data[k];
					update = true;
				}
			}, this);
			if (update) {
				this.set('query_const', query_const, { silent: true });
			}
		}
	},
	/**
	 * Add a facet filter
	 * @param {String} facet which facet
	 * @param {String} value which facet value
	 */
	addFacet: function(facet, value) {
		var facets = this.get('facets');
		
		if (facets[facet]) {
			//make sure its not a dupe
			if (_.indexOf(facets[facet], value) == -1) {
				facets[facet].push(value);
				this.trigger('search:initiate', { source: 'facet' });
				this.trigger('facet:add', { type: facet, value: value });
			}
		}
	},
	/**
	 * Set a facet filter as the only facet filter
	 * @param {String} facet which facet
	 * @param {String} value which facet value
	 * @param {Bool} [all=true] set as only facet or just as only value for the specific facet
	 * @param {Bool} [initiate=true] should we initiate a search when setting this facet
	 */
	setFacet: function(facet, value, all, initiate) {
		searchcontroller.debug(this.get('type')+' setFacet');
		var facets = _.clone(this.get('facets'));
		
		if (typeof all == 'undefined' || all) {
			f = _.keys(facets);			
			facets = {};
			_.each(f, function(v){
				facets[v] = [];
			}, this);
			facets[facet].push(value);
		} else {
			facets[facet] = [value];
		}
		this.set('facets', facets);
		if (typeof initiate == 'undefined' || initiate) {
			this.trigger('search:initiate', { source: 'facet' });
		}
	},
	/**
	 * Remove a facet (or all of them)
	 * @param {String} [facet] which facet (if undefined remove all)
	 * @param {String} [value] which facet value (if undefined remove all)
	 */
	removeFacet: function(facet, value) {
		var facets = _.clone(this.get('facets'));
		//searchcontroller.debug(facets);

		if (typeof facet == 'undefined') {
			//remove all
			f = _.keys(facets);
			
			facets = {};
			_.each(f, function(v){
				facets[v] = [];
			}, this);
			this.set('facets', facets);
			this.trigger('search:initiate', { source: 'facet' });
		}
		//remove one
		if (facets[facet]) {
			if (typeof value == 'undefined') {
				//remove the whole facet
				facets[facet] = [];
			} else {
				//remove specific value of facet			
				var i = _.indexOf(facets[facet], value);
				if (i > -1) {
					facets[facet].splice(i, 1);
				}
			}
			this.set('facets', facets);
			this.trigger('search:initiate', { source: 'facet' });
		}		
	},
	/**
	 * Remove All Facets
	 * @param bool query_too should we also clear search query
	 */
	removeAllFacets: function(query_too) {
		if (typeof query_too == 'undefined') {
			query_too = false;
		}
		//remove all facets
		var facets = _.clone(this.get('facets'));
		f = _.keys(facets);			
		facets = {};
		_.each(f, function(v){
			facets[v] = [];
		}, this);
		this.set('facets', facets);

		if (query_too && this.get('query_typed') !== '') {
			searchcontroller.set('query_typed', '');
			searchcontroller.trigger('search');
		} else {
			this.trigger('search:initiate', { source: 'facet' });
		}
	},
	/**
	 * Sets focus on an attribute after the search runs
	 */
	setFocus: function() {
		if (this.get('focus_target') !== '') {
			jQuery('#'+this.get('focus_target')).focus();
			this.set('focus_target', '');
		}
	}
	
});


//!ResultsList View
var ResultsList = Backbone.View.extend(
/** @lends ResultsList.prototype */
{
	
	model: SearchInterface,
	tagName: 'div',
	className: 's-srch-resultlist col-sm-12',
	item_template: '',
	attributes: { 'aria-live': 'polite' },
	
	/**
	 * Results list for SearchInterface
	 *
	 * @augments external:Backbone.View
	 * @constructs
	 */
    initialize: function(options) {
		searchcontroller.debug('ResultsList:initialize');
        this.listenTo(this.model, "search:retrieve", this.render);
		this.listenTo(this.model, "search:noresults", this.noResults);
    },
    /**
     * When results are retrieved, display them
     */
    render: function () {
		var $list = $('<ul class="list-unstyled s-srch-results"></ul>');
		var results = this.model.get('results');
		if(results && results.length > 0) {
			_.each(results, function(v,k,l){		
				$list.append(this.resultItem(v));
			}, this);
		}
		this.$el.html($list).attr({ 'aria-labelledby': 's-srch-params-'+this.model.get('id') });
		
		if (this.model.get('item_callback') !== '') {
			var self = this;
			var func = new Function(this.model.get('item_callback'));
			$list.find('li').each(function(i,el){
				//call item_callback with the LI element as this
				func.apply(this);
			});
		}
		
		return this;
    },
    /**
     * When no results are retrieved show something
     */
    noResults: function() {
		$(this.el).html('');
		return this;
    },
	/**
	 * A single result item
	 * @param {Object} item
	 * @return {Object} jQuery object
	 */
	resultItem: function(item) {
		var $li = $('<li></li>').addClass('s-srch-result');
		var html = '';
		
		if (this.model.get('item_template') === '') {
			this.model.set('item_template',
				'<a href="{{url}}">{{title}}</a>',
				{ silent: true });
		}
		if (this.item_template === '') {
			this.item_template = _.template( this.model.get('item_template') );
		}
		try {
			html = this.item_template(item);
		} catch(e) {
			searchcontroller.debug(e);
			return '';
		}
		
		return $li.html( html );
	}
	
});


//!SearchHeader View
var SearchHeader = Backbone.View.extend(
/** @lends SearchHeader.prototype */
{
	
	model: SearchInterface,
	tagName: 'div',
	className: 's-srch-header clearfix',
	
	events: {
		'click .s-srch-sorter': 'doSort',
	},
	
	/**
	 * Search header for results number, sorting
	 */
	initialize: function() {
		if (searchcontroller.get('layout') == 'bento') {
			this.$el.addClass('col-sm-12');
		} else {
			this.$el.addClass('col-sm-6');
		}
		this.render();
		this.listenTo(this.model, 'search:retrieve search:noresults', this.render);
	},
	/**
	 * Display the content
	 */
	render: function() {
		this.$el.html('');
	
		var total = this.model.get('total_results');
		var perPage = this.model.get('perpage');
		var offset = (this.model.get('page') - 1) * perPage;
		
		this.$rangeHeader = $('<div class="s-srch-range pull-left" role="status"></div>');
		this.$rangeHeader.html($('<span></span>').text(springSpace.Util.stringFormat(this.model.get('lang').srch_resrange, [Math.min(total, offset + 1) + ' - ' + Math.min(total, offset + perPage), total])));
		
		var sort_list = '';
		if (this.model.get('sort_options').length > 1) {
			var cur_sort = this.model.get('sort');
			_.each(this.model.get('sort_options'), function(v,k){
				var chk = (cur_sort.field == v.field && cur_sort.dir == v.dir) ? '<i class="fa fa-fw fa-check"></i>' : '<i class="fa fa-fw"></i>';
				sort_list += '<li><a href="#" role=button class="s-srch-sorter" data-field="'+v.field+'" data-direction="'+v.dir+'" aria-controls="s-srch-results-'+this.model.get('id')+'">'+chk+' '+v.label+'</a></li>';
				
			}, this);
		}
		
		if (sort_list !== '') {
			var o = '<div class="dropdown">'+
				'<button id="s-srch-sort-'+this.model.get('id')+'-btn" type="button" class="btn btn-default btn-xs" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">'+
					this.model.get('lang').srch_sorthead+' '+
					'<span class="caret"></span>'+
				'</button>'+
				'<ul class="dropdown-menu" aria-labelledby="s-srch-sort-'+this.model.get('id')+'-btn">'+
					sort_list+
				'</ul>'+
			'</div>';
			this.$rangeHeader.append(o);
		}
		
		this.$el.append([this.$rangeHeader]);
	},	
	/**
	 * Apply the new sort on click, trigger search
	 * @param {Object} e event object
	 */
	doSort: function(e) {
		e.preventDefault();
		
		var $a = $(e.currentTarget);
		var f = $a.attr('data-field');
		var d = $a.attr('data-direction');
		
		this.model.set('sort',  { field: f, dir: d });		
		this.model.set('focus_target', this.$('.dropdown button').attr('id'));
		this.model.trigger('search:initiate', { source: 'sort' });
	}

});

//!SearchFooter View
var SearchFooter = Backbone.View.extend(
/** @lends SearchFooter.prototype */
{
	
	model: SearchInterface,
	tagName: 'div',
	className: 's-srch-footer clearfix col-sm-6',
	
	events: { },
	
	/**
	 * Search footer for see more link
	 */
	initialize: function() {
		this.render();
		this.listenTo(this.model, 'search:retrieve search:noresults', this.render);
	},
	/**
	 * Display the content
	 */
	render: function() {
		this.$el.html('');
	
		if (searchcontroller.get('layout') == 'bento' && this.model.get('search_url')) {
			var $more = jQuery('<div></div>').addClass('s-srch-fulllink');
			var query = (this.model.get('query_typed')) ? this.model.get('query_typed') : '';
			var url = this.model.get('search_url').replace('{{query}}', encodeURIComponent(query));
			var $fulllink = jQuery('<a></a>').html( '<i class="fa fa-external-link"></i> '+this.model.get('lang').srch_seemore ).attr({ href: url, target: '_blank' });
			$more.append($fulllink);
			this.$el.append($more);
		}
	}
});

//!PaginationView
var PaginationView = Backbone.View.extend(
/** @lends PaginationView.prototype */
{
	model: SearchInterface,
	tagName: 'div',
	className: 's-srch-pagination',
	location: 'top',
	
	events: {
		'click .pagination a': 'changePage',	
	},
	
	initialize: function(options) {
		if (options.location) {
			this.location = options.location;
		}		
		
		if (this.location == 'bottom') {
			if (searchcontroller.get('layout') == 'bento') {
				this.$el.addClass('s-srch-pagination-bottom col-sm-6');
			} else {
				this.$el.addClass('s-srch-pagination-bottom col-sm-12');
			}
		} else {
			if (searchcontroller.get('layout') == 'bento') {
				this.$el.addClass('col-sm-4');
			} else {
				this.$el.addClass('col-sm-6');
			}
		}
		
		this.render();
		this.listenTo(this.model, 'search:retrieve search:noresults', this.render);
	},
	/**
	 * Build the page links
	 */
	render: function() {
		var total = this.model.get('total_results');
		var perPage = this.model.get('perpage');
		
		this.$pager = $('<ul class="pagination pull-right" role="listbox"></ul>').attr('aria-label', this.model.get('lang').srch_pagelabel);
		
		var totalPages = Math.ceil(total / perPage);
		var curPage = parseInt(this.model.get('page'), 10);
		
		if (totalPages > 1) {
			var pagelinks = [];
			if (curPage > 1) {
				//prev page link
				p = curPage-1;
				var $li = $('<li class="pager-step" role="presentation"></li>');
				var $a = $('<a>&lt;</a>').attr({ 'href': '#', 'data-page': p, 'aria-controls': 's-srch-results-'+this.model.get('id'), 'role': 'option' });
				$li.append($a);
				pagelinks.push($li);
			}
			
			//loop
			var startpage = ((curPage - 2) < 1) ? 1 : curPage - 2;
			var endpage = startpage + 4;
			if (endpage > totalPages) { endpage = totalPages; }
			var p = startpage;
			while (p <= endpage) {
				var $li = $('<li role="presentation"></li>');
				var $a = $('<a>'+p+'</a>').attr({ 'href': '#', 'data-page': p, 'aria-controls': 's-srch-results-'+this.model.get('id'), 'role': 'option' });
				if (p == curPage) {
					$li.addClass('active');
					$a.attr({ 'aria-selected': 'true' });
				}
				$li.append($a);
				pagelinks.push($li);
				p++;
			}
			
			if (curPage < totalPages) {
				//next prev link
				var p = curPage+1;
				var $li = $('<li class="pager-step" role="presentation"></li>');
				var $a = $('<a>&gt;</a>').attr({ 'href': '#', 'data-page': p, 'aria-controls': 's-srch-results-'+this.model.get('id'), 'role': 'option' });
				$li.append($a);
				pagelinks.push($li);
			}
			
			this.$pager.append( pagelinks );
		}
		
		this.$el.html(this.$pager);
	},
	/**
	 * Pagination click event
	 * sets the page attribute and triggers a search (passing along paginate=true so the page doesn't get reset)
	 * @param {Object} e event object
	 */
	changePage: function(e) {
		e.preventDefault();
		var page = $(e.currentTarget).attr('data-page');
		var curPage = this.model.get('page');
		
		if (curPage !== page) {
			this.model.set('page', page);
			this.model.trigger('search:initiate', { source: 'paginate' });
		}
	}

});


//!FacetView
var FacetView = Backbone.View.extend(
/** @lends FacetView.prototype */
{
	
	model: SearchInterface,
	tagName: 'div',
	className: 's-srch-facet',
	facetType: '',
	
	events: {
		'change input[type=checkbox]': 'toggleFacet',
		'hide.bs.collapse .s-srch-cloud': 'toggleCollapseIcon',
		'show.bs.collapse .s-srch-cloud': 'toggleCollapseIcon',
	},
	
	/**
	 * Facet display
	 */
	initialize: function(options) {
		if (options.facetType) {
			this.facetType = options.facetType;
		}
				
		this.listenTo(this.model, 'facets:retrieve', this.makeList);
		this.render();
	},	
	/**
	 * create the display
	 */
	render: function() {		
		return this;
	},
	/**
	 * Generate the list of facet values
	 */
	makeList: function() {
		return;		
	},
	/**
	 * Apply/remove facet via checkbox change event
	 */
	toggleFacet: function(e) {
		var $ch = $(e.currentTarget);
		
		var facet = $ch.attr('name');
		
		if ($ch.prop('checked') === true) {
			this.model.addFacet(this.facetType, facet);
		} else {
			this.model.removeFacet(this.facetType, facet);
		}
	},
	/**
	 * Toggle the facet visibility caret icon
	 */
	toggleCollapseIcon: function(e) {
		var $btn = jQuery(e.currentTarget).prev('h3').find('button span i');
		if ($btn.length === 0) { return; }
		if (e.type == 'hide') {
			$btn.removeClass('fa-caret-down').addClass('fa-caret-right');
		} else if (e.type == 'show') {
			$btn.removeClass('fa-caret-right').addClass('fa-caret-down');
		}
	}
	
});


//!CurrentParamsView
/**
 * Shows the currently selected facet limiters
 */
var CurrentParamsView = Backbone.View.extend(
/** @lends CurrentParamsView.prototype */
{
	model: SearchInterface,
	tagName: 'div',
	className: 'col-sm-12 hidden',
	events: {
		'click .removeAll': 'removeAll'
	},
	/**
	 * Facet display
	 */
	initialize: function() {
		this.render();
		this.listenTo(this.model, 'search:retrieve search:noresults', this.render);
	},
	/**
	 * create the display
	 */	
	render: function() {
		return this;
	},
	/**
	 * remove all limiters
	 * @param {Object} e click event object 
	 */
	removeAll: function(e) {
		e.preventDefault();
		this.model.removeFacet();	
	}
});
